import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";

import React from "react";
import Start from "./pages/Start";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

function NoMatch() {
  return (
    <div style={{ padding: 20 }}>
      <h2>404: Diese Seite existiert nicht</h2>
      <p>
        Diese Route ist nicht vorhanden, benutze den Browser-Back-Button oder
        starte die Anwendung erneut.
      </p>
    </div>
  );
}

const MainRouter = () => {
  return (
    
    <Router >
      {//"  basename="/test/containerklinik"
      }
      <Routes >
        <Route path="/" element={<Start />} />

        <Route path="/impressum" element={<Impressum />} />

        <Route path="/datenschutz" element={<Datenschutz />} />

        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Router>
  );
};

export default MainRouter;
